function musicHero()
{
    const musicAudio = document.getElementById('music-audio');
    const playBtn = document.getElementById('music-btn');
    const volumeControl = document.getElementById('volume');

    if (playBtn) {
        playBtn.addEventListener('click', function () {
            if (!musicAudio.paused) {
                pauseMusic();
            } else {
                let volume = parseFloat(volumeControl.value)
                if (volume === 0) {
                    volumeControl.value = 0.5;
                    musicAudio.volume = 0.5;
                }
                playMusic();
            }
        });
    }

    if (volumeControl) {
        volumeControl.addEventListener("input", function () {
            let volume = parseFloat(volumeControl.value);
            if (volume === 0) {
                musicAudio.volume = volume;
                pauseMusic();
            } else {
                musicAudio.volume = volume;
                playMusic();
            }
        });
    }

    function pauseMusic()
    {
        musicAudio.pause();
        playBtn.classList.add('is-paused');
    }

    function playMusic()
    {
        musicAudio.play();
        playBtn.classList.remove('is-paused');
    }
}

function musicContentProduct()
{
    const musicAudios = document.querySelectorAll('[id^="sample-music-"]');
    const playButtons = document.querySelectorAll('[id^="sample-btn-"]');

    playButtons.forEach((playBtn) => {
        const productId = playBtn.id.split('-').pop();
        const musicAudio = document.getElementById(`sample-music-${productId}`);

        playBtn.addEventListener('click', function () {
            if (!musicAudio.paused) {
                pauseMusic(musicAudio, playBtn);
            } else {
                musicAudios.forEach((audio) => {
                    audio.pause();
                    audio.currentTime = 0;
                });
                playButtons.forEach((btn) => btn.classList.add('is-paused'));

                playMusic(musicAudio, playBtn);
            }
        });
    });

    function pauseMusic(audio, button)
    {
        audio.pause();
        button.classList.add('is-paused');
    }

    function playMusic(audio, button)
    {
        audio.currentTime = 0;
        audio.play();
        button.classList.remove('is-paused');
    }
}

function singleProductSample()
{
    const musicAudio = document.getElementById('single-product-sample-music');
    const playBtn = document.getElementById('single-product-sample-btn');
    const playBtnIcon = document.getElementById('single-product-sample-btn-icon');

    if (playBtn) {
        playBtn.addEventListener('click', function () {
            if (!musicAudio.paused) {
                pauseMusic();
            } else {
                playMusic();
            }
        });
    }

    function pauseMusic()
    {
        musicAudio.pause();
        playBtnIcon.classList.add('is-paused');
    }

    function playMusic()
    {
        musicAudio.currentTime = 0;
        musicAudio.play();
        playBtnIcon.classList.remove('is-paused');
    }
}

export { musicHero, musicContentProduct, singleProductSample };
